import React from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import {Breakpoints} from 'wobi-web-common';
import {
  DEFAULT_DESTINATION_BACKGROUND,
  DESTINATION_CHANGE_EVENT,
  getDestinationBackground,
  readPersistedDestinations,
} from './destinationBackgrounds';

/**
 * DestBackdrop — decorative travel photo positioned at the inline-start (left in page)
 * with a gradient mask fade. Hidden on mobile. Matches wobi-travel-funnel reference.
 */
const DestBackdrop = () => {
  const isMobile = useMediaQuery(`(max-width:${Breakpoints.mobile}px)`);
  const [targetCountries, setTargetCountries] = React.useState(readPersistedDestinations);
  const fade = 'linear-gradient(to right, #000 30%, transparent 100%), ' +
    'linear-gradient(to bottom, #000 62%, transparent 100%)';
  const background = getDestinationBackground(targetCountries);

  React.useEffect(() => {
    const handleDestinationChange = (event) => {
      setTargetCountries(Array.isArray(event.detail?.targetCountries) ?
        event.detail.targetCountries : []);
    };

    window.addEventListener(DESTINATION_CHANGE_EVENT, handleDestinationChange);
    return () => window.removeEventListener(DESTINATION_CHANGE_EVENT, handleDestinationChange);
  }, []);

  if (isMobile) {
    return null;
  }

  return (
    <div
      className='dest-bg'
      aria-hidden='true'
      data-testid='destination-backdrop'
      style={{
        position: 'absolute',
        top: 83,
        left: 0,
        width: 'clamp(300px, 32vw, 640px)',
        height: 'calc(100vh - 83px)',
        zIndex: 0,
        pointerEvents: 'none',
        WebkitMaskImage: fade,
        maskImage: fade,
        WebkitMaskComposite: 'source-in',
        maskComposite: 'intersect',
      }}
    >
      <img
        key={background}
        src={background}
        alt=''
        onError={(event) => {
          event.currentTarget.onerror = null;
          event.currentTarget.src = DEFAULT_DESTINATION_BACKGROUND;
        }}
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          objectPosition: 'center top',
        }}
      />
    </div>
  );
};

export default DestBackdrop;
